import {
  Button,
  Stack
} from '@mui/material';

import { useAccessState } from 'modules/common';

import {
  RemoveMembershipModal,
  SaveMembershipModal
} from 'modules/components/layer17';
import { UserDetailCard } from 'modules/components/layer20';
import { ActivityHeaderSectionVerticalLayout } from 'modules/components/layer32';
import React, { useState } from 'react';


export type PersonHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PersonHeaderSectionProps) => {
  return (
    <ActivityHeaderSectionVerticalLayout.FC
      actionButtonsGroup={<ActionButtonsGroup />}
      title='User Details'
      subTitle=''
    >
      <UserDetailCard.FC />
    </ActivityHeaderSectionVerticalLayout.FC>
  );
};


type ActionButtonsGroupProps = {

};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroupProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isRemoveVisible,
    setIsRemoveVisible
  ] = useState(false);

  const access = useAccessState('Membership');

  return (
    <>
      {
        isVisible && (
          <SaveMembershipModal.FC
            id=''
            isVisible={isVisible}
            handleClose={() => setIsVisible(() => false)}
          />

        )
      }
      {
        isRemoveVisible && (
          <RemoveMembershipModal.FC
            id=''
            isVisible={isRemoveVisible}
            handleClose={() => setIsRemoveVisible(() => false)}
          />

        )
      }
      <Stack
        direction='row'
        columnGap='1rem'
      >
        <Button
          variant='contained'
          color='error'
          disabled={!access.delete}
          onClick={() => setIsRemoveVisible(() => true)}
        >
          Remove Membership
        </Button>
        <Button
          variant='outlined'
          disabled={!access.update}
          onClick={() => setIsVisible(() => true)}
        >
          Manage Roles
        </Button>
      </Stack>
    </>
  );
};

